import { RouterProvider } from 'react-router-dom';
import { ReactQueryProvider, ThemeProvider } from '@/providers';
import { router } from '@/router/routes';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './features/auth/providers/AuthProvider';
import { CustomTourProvider } from './providers/TourProvider';
import { PasswordChangeModal } from './features/auth/components/PasswordChangeModal';
import { useAuthContext } from './features/auth/providers/AuthProvider';

const AppContent = () => {
  const { showPasswordModal, setShowPasswordModal } = useAuthContext();

  return (
    <>
      <RouterProvider router={router} />
      <PasswordChangeModal
        isOpen={showPasswordModal}
        onClose={() => setShowPasswordModal(false)}
      />
    </>
  );
};

export default function App() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <ReactQueryProvider>
        <ThemeProvider>
          <Toaster
            position="bottom-left"
            toastOptions={{
              duration: 4000,
            }}
          />
          <AuthProvider>
            <CustomTourProvider>
              <AppContent />
            </CustomTourProvider>
          </AuthProvider>
        </ThemeProvider>
      </ReactQueryProvider>
    </div>
  );
}
